import React from 'react';
import loc from '../assets/loc.png';
import aplace1 from '../assets/aplace1.png';
import aplace2 from '../assets/aplace2.png';
import aplace3 from '../assets/aplace3.png';
import aplace4 from '../assets/aplace4.png';
import aplace5 from '../assets/aplace5.png';
import aplace6 from '../assets/aplace6.png';
import aplace7 from '../assets/aplace7.png';
import aplace8 from '../assets/aplace8.png';

import dis1 from '../assets/dis1.png';
import Star from '../assets/Star.png';
import dis2 from '../assets/dis2.png';
import dis3 from '../assets/dis3.png';
import dis4 from '../assets/dis4.png';
import dis5 from '../assets/dis5.png';
import dis6 from '../assets/dis6.png';
import dis7 from '../assets/dis7.png';
import dis8 from '../assets/dis8.png';
import './Aplace.css';


const Aplace = () => {
  return (
    <div>
     
     <header>
      
      <div className="to-visit">
          <ul className="places-list">
            <li className="vis">Resturant</li>
            <li className="vis">Cottage</li>
            <li className="vis">Castle</li>
            <li className="vis">Fantast city</li>
            <li className="vis">Beach</li>
            <li className="vis">Carbins</li>
            <li className="vis">Off-grid</li>
            <li className="vis">Farms</li>
            <li className='location'>
            <img className="" src={loc} alt="locpic"/>
            </li>
          </ul>
        </div>
     
     
     
     
      </header>

      <main>

      <div className="places-content">
            <div className="places">

            <div className="places-img">
    <img className="pics" src={dis1} alt="dis"/>
    <div className="resort-details">
    <p className='p1'>Desert king</p>
    <p className='p2'>1MBT per night</p>
    </div>
    
    <div className="resort-details">
       <p className='p1'>2345km away</p>
    <p className='p2'>available for 2weeks stay</p>
    </div>
    
    <div className="stars">
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    </div>


    </div>


    <div className="places-img">
    <img className="pics" src={dis2} alt="dis"/>
    <div className="resort-details">
    <p className='p1'>Desert king</p>
    <p className='p2'>1MBT per night</p>
    </div>
    
    <div className="resort-details">
       <p className='p1'>2345km away</p>
    <p className='p2'>available for 2weeks stay</p>
    </div>
    
    <div className="stars">
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    </div>


    </div>

    <div className="places-img">
    <img className="pics" src={dis3} alt="dis"/>
    <div className="resort-details">
    <p className='p1'>Desert king</p>
    <p className='p2'>1MBT per night</p>
    </div>
    
    <div className="resort-details">
       <p className='p1'>2345km away</p>
    <p className='p2'>available for 2weeks stay</p>
    </div>
    
    <div className="stars">
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    </div>


    </div>

    <div className="places-img">
    <img className="pics" src={dis4} alt="dis"/>
    <div className="resort-details">
    <p className='p1'>Desert king</p>
    <p className='p2'>1MBT per night</p>
    </div>
    
    <div className="resort-details">
       <p className='p1'>2345km away</p>
    <p className='p2'>available for 2weeks stay</p>
    </div>
    
    <div className="stars">
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    </div>


    </div>

    <div className="places-img">
    <img className="pics" src={dis5} alt="dis"/>
    <div className="resort-details">
    <p className='p1'>Desert king</p>
    <p className='p2'>1MBT per night</p>
    </div>
    
    <div className="resort-details">
       <p className='p1'>2345km away</p>
    <p className='p2'>available for 2weeks stay</p>
    </div>
    
    <div className="stars">
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    </div>


    </div>

    <div className="places-img">
    <img className="pics" src={dis6} alt="dis"/>
    <div className="resort-details">
    <p className='p1'>Desert king</p>
    <p className='p2'>1MBT per night</p>
    </div>
    
    <div className="resort-details">
       <p className='p1'>2345km away</p>
    <p className='p2'>available for 2weeks stay</p>
    </div>
    
    <div className="stars">
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    </div>


    </div>

    <div className="places-img">
    <img className="pics" src={dis7} alt="dis"/>
    <div className="resort-details">
    <p className='p1'>Desert king</p>
    <p className='p2'>1MBT per night</p>
    </div>
    
    <div className="resort-details">
       <p className='p1'>2345km away</p>
    <p className='p2'>available for 2weeks stay</p>
    </div>
    
    <div className="stars">
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    </div>


    </div>
    <div className="places-img">
    <img className="pics" src={dis8} alt="dis"/>
    <div className="resort-details">
    <p className='p1'>Desert king</p>
    <p className='p2'>1MBT per night</p>
    </div>
    
    <div className="resort-details">
       <p className='p1'>2345km away</p>
    <p className='p2'>available for 2weeks stay</p>
    </div>
    
    <div className="stars">
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    <img className="star" src={Star} alt="starpic"/>
    </div>


    </div>
    
   


 <div className="places-img">
<img className="pics" src={aplace1} alt="dis"/>

<div className="resort-details">
<p className='p1'>Desert king</p>
<p className='p2'>1MBT per night</p>
</div>


<div className="resort-details">
<p className='p1'>2345km away</p>
<p className='p2'>available for 2weeks stay</p>
</div>


<div className="stars">
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
</div>

</div>

<div className="places-img">
<img className="pics" src={aplace2} alt="dis"/>

<div className="resort-details">
<p className='p1'>Desert king</p>
<p className='p2'>1MBT per night</p>
</div>


<div className="resort-details">
<p className='p1'>2345km away</p>
<p className='p2'>available for 2weeks stay</p>
</div>


<div className="stars">
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
</div>

</div>


<div className="places-img">
<img className="pics" src={aplace3} alt="dis"/>

<div className="resort-details">
<p className='p1'>Desert king</p>
<p className='p2'>1MBT per night</p>
</div>


<div className="resort-details">
<p className='p1'>2345km away</p>
<p className='p2'>available for 2weeks stay</p>
</div>


<div className="stars">
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
</div>

</div>


<div className="places-img">
<img className="pics" src={aplace4} alt="dis"/>

<div className="resort-details">
<p className='p1'>Desert king</p>
<p className='p2'>1MBT per night</p>
</div>


<div className="resort-details">
<p className='p1'>2345km away</p>
<p className='p2'>available for 2weeks stay</p>
</div>


<div className="stars">
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
</div>

</div>


<div className="places-img">
<img className="pics" src={aplace5} alt="dis"/>

<div className="resort-details">
<p className='p1'>Desert king</p>
<p className='p2'>1MBT per night</p>
</div>


<div className="resort-details">
<p className='p1'>2345km away</p>
<p className='p2'>available for 2weeks stay</p>
</div>


<div className="stars">
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
</div>

</div>


<div className="places-img">
<img className="pics" src={aplace6} alt="dis"/>

<div className="resort-details">
<p className='p1'>Desert king</p>
<p className='p2'>1MBT per night</p>
</div>


<div className="resort-details">
<p className='p1'>2345km away</p>
<p className='p2'>available for 2weeks stay</p>
</div>


<div className="stars">
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
</div>

</div>
 <div className="places-img">
<img className="pics" src={aplace7} alt="dis"/>

<div className="resort-details">
<p className='p1'>Desert king</p>
<p className='p2'>1MBT per night</p>
</div>


<div className="resort-details">
<p className='p1'>2345km away</p>
<p className='p2'>available for 2weeks stay</p>
</div>


<div className="stars">
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
</div>

</div>
 <div className="places-img">
<img className="pics" src={aplace8} alt="dis"/>

<div className="resort-details">
<p className='p1'>Desert king</p>
<p className='p2'>1MBT per night</p>
</div>


<div className="resort-details">
<p className='p1'>2345km away</p>
<p className='p2'>available for 2weeks stay</p>
</div>


<div className="stars">
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
<img className="star" src={Star} alt="starpic"/>
</div>

</div>

</div>

</div>
      </main>
    </div>
  )
}

export default Aplace
